/** Symbols grouped by category for UI dropdowns. Mirrors @forgealpha/core SYMBOL_CATEGORIES. */
export const SYMBOL_CATEGORIES: Record<string, string[]> = {
  Metals: ['XAUUSD', 'XAGUSD'],
  'Forex Majors': ['EURUSD', 'GBPUSD', 'USDJPY', 'AUDUSD', 'USDCAD', 'USDCHF', 'NZDUSD'],
  'Forex Crosses': ['EURGBP', 'EURJPY'],
  Crypto: ['BTCUSD', 'ETHUSD'],
  Indices: ['US30', 'NAS100', 'SPX500', 'UK100', 'DE40', 'JP225'],
  Energy: ['USOIL', 'UKOIL'],
  'Step Index': ['Step Index 100', 'Step Index 200', 'Step Index 300', 'Step Index 400', 'Step Index 500'],
  'Crash/Boom': ['Boom 300 Index', 'Boom 500 Index', 'Boom 1000 Index', 'Crash 300 Index', 'Crash 500 Index', 'Crash 1000 Index'],
  'Volatility': ['Volatility 10 Index', 'Volatility 25 Index', 'Volatility 50 Index', 'Volatility 75 Index', 'Volatility 100 Index'],
  'Jump': ['Jump 10 Index', 'Jump 25 Index', 'Jump 50 Index', 'Jump 75 Index', 'Jump 100 Index'],
  'Range Break': ['Range Break 100 Index', 'Range Break 200 Index'],
  'Daily Reset': ['Bear Market Index', 'Bull Market Index'],
};

/** Flat list of all supported symbols. */
export const SUPPORTED_SYMBOLS = Object.values(SYMBOL_CATEGORIES).flat();

/** Categories that are Deriv synthetic instruments (not on TwelveData). */
export const DERIV_CATEGORIES = new Set(['Step Index', 'Crash/Boom', 'Volatility', 'Jump', 'Range Break', 'Daily Reset']);

/** Set of all Deriv synthetic symbols for O(1) lookup. */
const DERIV_SYMBOLS = new Set(
  [...DERIV_CATEGORIES].flatMap((cat) => SYMBOL_CATEGORIES[cat] ?? []),
);

/** Whether a symbol is a Deriv synthetic instrument. */
export function isDerivSymbol(symbol: string): boolean {
  return DERIV_SYMBOLS.has(symbol);
}

/**
 * Max backtest days for Deriv symbols (limited by API historical depth).
 * Returns Infinity for non-Deriv symbols.
 */
export function getMaxBacktestDays(symbol: string | undefined): number {
  if (!symbol || !isDerivSymbol(symbol)) return Infinity;
  return 200; // Deriv API max reliable depth is ~200 days at 1h
}
